export default __webpack_public_path__ + "static/image01-3cd92c8d3fc27297e7b84a0791d9c4af.webp";